import axios from '../axios';
// 采购订单列表
export const getPurOrderPage = data => {
  return axios({
    url: '/api/sys/pur/order/getPurOrderPage',
    method: 'post',
    data
  })
};
// 采购订单列表(单条)
export const getPurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/getPurOrder',
    method: 'post',
    data
  })
};
export const submitData = data => {
  return axios({
    url: '/api/sys/stk/application/submitData',
    method: 'post',
    data
  })
};
// 采购到货单浮动合同列表
export const getPurOrderByContractCategoryPage = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurOrderByContractCategoryPage',
    method: 'post',
    data
  })
};
// 采购订单生成合同号
export const getContractId = data => {
  return axios({
    url: '/api/sys/pur/order/getContractId',
    method: 'post',
    data
  })
};
// 采购合同生成合同编号
export const getContractNumber = data => {
  return axios({
    url: '/api/sys/pur/order/getContractNumber',
    method: 'post',
    data
  })
};
// 采购订单生成订单编号
export const getOrderContractNumber = data => {
  return axios({
    url: '/api/sys/pur/order/getOrderContractNumber',
    method: 'post',
    data
  })
};
// 采购订单列表申请
export const submitPurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/submitPurOrder',
    method: 'post',
    data
  })
};
// 采购订单列表确认 finReviewFlag=1财务部门确认
export const finReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/finReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表确认 finReviewFlag=1财务部门反确认
export const unfinReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/unfinReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购财务确认的接口
export const finConfirmPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/finConfirmPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表确认
export const auditPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/auditPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表反确认
export const unauditPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/unauditPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表提交(多)
export const submitApplyPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/submitApplyPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表提交(单)
export const submitApplyPurOrderSingle = data => {
  return axios({
    url: '/api/sys/pur/order/submitApplyPurOrderSingle',
    method: 'post',
    data
  })
};
// 采购订单列表反提交
export const unsubmitApplyPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/unsubmitApplyPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表卸货开始
export const beginDelivery = data => {
  return axios({
    url: '/api/sys/pur/order/beginDelivery',
    method: 'post',
    data
  })
};
// 采购订单列表卸货取消
export const unbeginDelivery = data => {
  return axios({
    url: '/api/sys/pur/order/unbeginDelivery',
    method: 'post',
    data
  })
};
// 采购订单列表开始/结束送货
export const startDelivering = data => {
  return axios({
    url: '/api/sys/pur/order/startDelivering',
    method: 'post',
    data
  })
};
// 采购订单列表卸货结束
export const endDelivery = data => {
  return axios({
    url: '/api/sys/pur/order/endDelivery',
    method: 'post',
    data
  })
};
// 采购订单列表卸货结束取消
export const unendDelivery = data => {
  return axios({
    url: '/api/sys/pur/order/unendDelivery',
    method: 'post',
    data
  })
};
// 采购订单上传文件和图片
export const uploadImageAndFree = data => {
  return axios({
    url: '/api/sys/pur/order/uploadImageAndFree',
    method: 'post',
    data
  })
};
// 采购订单列表关闭
export const closePurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/closePurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表技术部门确认
export const qeReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/qeReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表技术部门反确认
export const unqeReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/unqeReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表财务部门确认
export const purReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/purReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表财务部门反确认
export const unpurReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/unpurReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表总经办确认
export const hrReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/hrReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表总经办反确认
export const unhrReviewPurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/unhrReviewPurOrders',
    method: 'post',
    data
  })
};
// 采购订单执行表列表
export const getPurOrderExecutionPage = data => {
  return axios({
    url: '/api/sys/pur/order/getPurOrderExecutionPage',
    method: 'post',
    data
  })
};
// 导出采购订单执行表列表
export const exportPurOrderExecution = data => {
  return axios({
    url: '/api/sys/pur/order/exportPurOrderExecution',
    method: 'post',
    data
  })
};
// 采购合同对账单
export const exportPurAccountStatement = data => {
  return axios({
    url: '/api/sys/pur/order/exportPurAccountStatement',
    method: 'post',
    data
  })
};
// 采购入库 查商品最后一次记录,获取金额
export const getStkInPurchaseLastRecord = data => {
  return axios({
    url: '/api/sys/stk/getStkInPurchaseLastRecord',
    method: 'post',
    data
  })
};
// 采购订单列表反审核
export const unAudit = data => {
  return axios({
    url: '/api/sys/pur/unAudit',
    method: 'post',
    data
  })
};
// 采购订单列表删除
export const deletePurOrders = data => {
  return axios({
    url: '/api/sys/pur/order/deletePurOrders',
    method: 'post',
    data
  })
};
// 采购订单中止
export const finishPurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/finishPurOrder',
    method: 'post',
    data
  })
};
// 采购订单汇总
export const summaryPurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/summaryPurOrder',
    method: 'post',
    data
  })
};
// 采购订单列表作废
export const invalidOrder = data => {
  return axios({
    url: '/api/sys/pur/invalidOrder',
    method: 'post',
    data
  })
};
// 采购订单列表关闭
export const closeOrder = data => {
  return axios({
    url: '/api/sys/pur/closeOrder',
    method: 'post',
    data
  })
};
// 采购订单列表保存
export const savePurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/savePurOrder',
    method: 'post',
    data
  })
};
// 采购订单列表修改
export const updatePurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/updatePurOrder',
    method: 'post',
    data
  })
};
// 合同关闭和开启
export const closeAndTurnOn = data => {
  return axios({
    url: '/api/sys/pur/order/closeAndTurnOn',
    method: 'post',
    data
  })
};
// 采购订单列表修改(审核后)
export const updateReviewPurOrder = data => {
  return axios({
    url: '/api/sys/pur/order/updateReviewPurOrder',
    method: 'post',
    data
  })
};

// 采购订单明细列表
export const getPurOrderEntryPage = data => {
  return axios({
    url: '/api/sys/pur/order/entry/getPurOrderEntryPage',
    method: 'post',
    data
  })
};
// 送货单进出地磅图片
export const getImageByIdPurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/getImageByIdPurArrival',
    method: 'post',
    data
  })
};
// 采购订单明细列表删除
export const deletePurOrderEntrys = data => {
  return axios({
    url: '/api/sys/pur/deletePurOrderEntrys',
    method: 'post',
    data
  })
};
// 采购订单明细列表保存
export const savePurOrderEntry = data => {
  return axios({
    url: '/api/sys/pur/savePurOrderEntry',
    method: 'post',
    data
  })
};
// 采购订单明细列表修改
export const updatePurOrderEntry = data => {
  return axios({
    url: '/api/sys/pur/updatePurOrderEntry',
    method: 'post',
    data
  })
};

// 查询单条采购到货单
export const getPurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurArrival',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表
export const getPurArrivalSettleNoPage = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurArrivalSettleNoPage',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表部门审核
export const audit1Flag = data => {
  return axios({
    url: '/api/sys/pur/arrival/audit1Flag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表部门反审核
export const unAudit1Flag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unAudit1Flag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表仓管审核
export const audit2Flag = data => {
  return axios({
    url: '/api/sys/pur/arrival/audit2Flag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表仓管反审核
export const unAudit2Flag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unAudit2Flag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表入库审核
export const audit3Flag = data => {
  return axios({
    url: '/api/sys/pur/arrival/audit3Flag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表入库反审核
export const unAudit3Flag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unAudit3Flag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表提交
export const settleSubmitFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/settleSubmitFlag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表反提交
export const unSettleSubmitFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unSettleSubmitFlag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表审核
export const settleAuditFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/settleAuditFlag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表反审核
export const unSettleAuditFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unSettleAuditFlag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表复核
export const recheckFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/recheckFlag',
    method: 'post',
    data
  })
};
// 采购到货单结算单列表反复核
export const unreCheckFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unreCheckFlag',
    method: 'post',
    data
  })
};
// 车辆统计
export const carNoStatistics = data => {
  return axios({
    url: '/api/sys/pur/arrival/carNoStatistics',
    method: 'post',
    data
  })
};
// 采购到货单列表
export const getPurArrivalPage = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurArrivalPage',
    method: 'post',
    data
  })
};
// 修改到货数量
export const updateBaseQuantity = data => {
  return axios({
    url: '/api/sys/pur/arrival/updateBaseQuantity',
    method: 'post',
    data
  })
};
// 修改到货数量审核
export const baseQuantityConfirm = data => {
  return axios({
    url: '/api/sys/pur/arrival/baseQuantityConfirm',
    method: 'post',
    data
  })
};
// 过磅重量修改
export const updPurArrivalWeight = data => {
  return axios({
    url: '/api/sys/pur/arrival/updPurArrivalWeight',
    method: 'post',
    data
  })
};
// 保存采购到货单
export const savePurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/savePurArrival',
    method: 'post',
    data
  })
};
// 修改采购到货单
export const updatePurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/updatePurArrival',
    method: 'post',
    data
  })
};
// 修改采购到货单
export const modifyPurArrivalWeight = data => {
  return axios({
    url: '/api/sys/pur/arrival/modifyPurArrivalWeight',
    method: 'post',
    data
  })
};
// 变更到货单(评铁前)
export const updatePurContractIdbefore = data => {
  return axios({
    url: '/api/sys/pur/arrival/updatePurContractIdbefore',
    method: 'post',
    data
  })
};
// 修改采购到货单(二次重之后)
export const updatePurContractId = data => {
  return axios({
    url: '/api/sys/pur/arrival/updatePurContractId',
    method: 'post',
    data
  })
};
// 采购到货单确认后修改NFC
export const updateNfc = data => {
  return axios({
    url: '/api/sys/pur/arrival/updateNfc',
    method: 'post',
    data
  })
};
// 采购到货单删除
export const deletePurArrivals = data => {
  return axios({
    url: '/api/sys/pur/arrival/deletePurArrivals',
    method: 'post',
    data
  })
};
// 采购到货单确认
export const auditPurArrivals = data => {
  return axios({
    url: '/api/sys/pur/arrival/auditPurArrivals',
    method: 'post',
    data
  })
};
// 采购到货单反确认
export const unauditPurArrivals = data => {
  return axios({
    url: '/api/sys/pur/arrival/unauditPurArrivals',
    method: 'post',
    data
  })
};
// 采购到货单确认（单个）
export const auditPurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/auditPurArrival',
    method: 'post',
    data
  })
};
// 采购到货单反确认（单个）
export const cancelAuditPurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/cancelAuditPurArrival',
    method: 'post',
    data
  })
};
// 修改结算单价
export const updateFinalSettlePrice = data => {
  return axios({
    url: '/api/sys/pur/arrival/updateFinalSettlePrice',
    method: 'post',
    data
  })
};
// 修改结算单价审批
export const finalSettlePriceFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/finalSettlePriceFlag',
    method: 'post',
    data
  })
};
// 采购结算单-确认
export const getFinalSettleList = data => {
  return axios({
    url: '/api/sys/pur/arrival/getFinalSettleList',
    method: 'post',
    data
  })
};
// 采购结算单-反确认
export const getUnFinalSettleList = data => {
  return axios({
    url: '/api/sys/pur/arrival/getUnFinalSettleList',
    method: 'post',
    data
  })
};
// 结算(反向开票)
export const settleReverse = data => {
  return axios({
    url: '/api/sys/pur/arrival/settleReverse',
    method: 'post',
    data
  })
};
// 送货单列表船运完成
export const achieve = data => {
  return axios({
    url: '/api/sys/pur/achieve',
    method: 'post',
    data
  })
};
// 送货单列表作废
export const invalidArrival = data => {
  return axios({
    url: '/api/sys/pur/invalidArrival',
    method: 'post',
    data
  })
};
// 送货单列表关闭
export const closeArrival = data => {
  return axios({
    url: '/api/sys/pur/closeArrival',
    method: 'post',
    data
  })
};
// 送货单车辆列表
export const getPurArrivalCarPage = data => {
  return axios({
    url: '/api/sys/pur/getPurArrivalCarPage',
    method: 'post',
    data
  })
};
// 送货单车辆列表保存
export const savePurArrivalCar = data => {
  return axios({
    url: '/api/sys/pur/savePurArrivalCar',
    method: 'post',
    data
  })
};
// 送货单车辆列表删除
export const deletePurArrivalCars = data => {
  return axios({
    url: '/api/sys/pur/deletePurArrivalCars',
    method: 'post',
    data
  })
};
// 付款单列表
export const getFinPaymentPage = data => {
  return axios({
    url: '/api/sys/fin/payment/getFinPaymentPage',
    method: 'post',
    data
  })
};
// 预付款到货情况列表
export const getAdvancePurArrivalCircumstance = data => {
  return axios({
    url: '/api/sys/fin/payment/getAdvancePurArrivalCircumstance',
    method: 'post',
    data
  })
};
//保存付款单
export const saveFinPayment = data => {
  return axios({
    url: '/api/sys/fin/payment/saveFinPayment',
    method: 'post',
    data
  })
};
//修改付款单
export const updateFinPayment = data => {
  return axios({
    url: '/api/sys/fin/payment/updateFinPayment',
    method: 'post',
    data
  })
};
//删除付款单
export const deleteFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/deleteFinPayments',
    method: 'post',
    data
  })
};
// 新增预付款时查询预付金额
export const getPrepaidAmount = data => {
  return axios({
    url: '/api/sys/pur/order/getPrepaidAmount',
    method: 'post',
    data
  })
};
// 付款单列表提交
export const submitFinPayment = data => {
  return axios({
    url: '/api/sys/fin/payment/submitFinPayment',
    method: 'post',
    data
  })
};
//付款单审核(部门)
export const auditFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/auditFinPayments',
    method: 'post',
    data
  })
};
//付款单反审核(部门)
export const unauditFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/unauditFinPayments',
    method: 'post',
    data
  })
};
//付款单反审核(分管)
export const dicReviewFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/dicReviewFinPayments',
    method: 'post',
    data
  })
};
//付款单反审核(分管)
export const undicReviewFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/undicReviewFinPayments',
    method: 'post',
    data
  })
};
//付款单审核(财务)
export const finReviewFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/finReviewFinPayments',
    method: 'post',
    data
  })
};
//付款单反审核(财务)
export const unfinFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/unfinFinPayments',
    method: 'post',
    data
  })
};
//付款单审核(财务经理)
export const finConfirmFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/finConfirmFinPayments',
    method: 'post',
    data
  })
};
//付款单审核(总经办)
export const hrReviewFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/hrReviewFinPayments',
    method: 'post',
    data
  })
};
//付款单反审核(总经办)
export const unhrReviewFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/unhrReviewFinPayments',
    method: 'post',
    data
  })
};
//付款单确认
export const payPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/payPayments',
    method: 'post',
    data
  })
};
//付款单反确认
export const unpayPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/unpayPayments',
    method: 'post',
    data
  })
};
//付款确认
export const finPaymentFlag = data => {
  return axios({
    url: '/api/sys/fin/payment/finPaymentFlag',
    method: 'post',
    data
  })
};
//付款反确认(取消付款)
export const unfinPaymentFlag = data => {
  return axios({
    url: '/api/sys/fin/payment/unfinPaymentFlag',
    method: 'post',
    data
  })
};
//保存付款单
export const getAdvancePayment = data => {
  return axios({
    url: '/api/sys/fin/payment/getAdvancePayment',
    method: 'post',
    data
  })
};
//入账
export const finAccountFlag = data => {
  return axios({
    url: '/api/sys/fin/payment/finAccountFlag',
    method: 'post',
    data
  })
};
//反入账(取消入账)
export const unfinAccountFlag = data => {
  return axios({
    url: '/api/sys/fin/payment/unfinAccountFlag',
    method: 'post',
    data
  })
};
//付款单作废
export const cancelFinPayments = data => {
  return axios({
    url: '/api/sys/fin/payment/cancelFinPayments',
    method: 'post',
    data
  })
};
//付款单打印次数
export const finPaymentPrint = data => {
  return axios({
    url: '/api/sys/fin/payment/finPaymentPrint',
    method: 'post',
    data
  })
};
//付款单明细开票信息采购审批
export const procuretInvoic = data => {
  return axios({
    url: '/api/sys/fin/payment/entry/procuretInvoic',
    method: 'post',
    data
  })
};
//付款单明细开票信息财务反审批
export const unprocuretInvoic = data => {
  return axios({
    url: '/api/sys/fin/payment/entry/unprocuretInvoic',
    method: 'post',
    data
  })
};
//付款单明细开票信息财务审批
export const financeInvoic = data => {
  return axios({
    url: '/api/sys/fin/payment/entry/financeInvoic',
    method: 'post',
    data
  })
};
//付款单明细开票信息财务反审批
export const unfinanceInvoic = data => {
  return axios({
    url: '/api/sys/fin/payment/entry/unfinanceInvoic',
    method: 'post',
    data
  })
};
// 销售运费付款承运商列表
export const getSalCarrierList = data => {
  return axios({
    url: '/api/sys/sal/delivery/getSalCarrierList',
    method: 'post',
    data
  })
};
// 采购运费付款承运商列表
export const getPurCarrierList = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurCarrierList',
    method: 'post',
    data
  })
};
// 修改发票
export const updateFinPaymentEntry = data => {
  return axios({
    url: '/api/sys/fin/payment/updateFinPaymentEntry',
    method: 'post',
    data
  })
};
// 地磅设备维护列表
export const getBaseLoadometerPage = data => {
  return axios({
    url: '/api/sys/base/getBaseLoadometerPage',
    method: 'post',
    data
  })
};
// 送货单一次过磅
export const onceWeigh = data => {
  return axios({
    url: '/api/sys/pur/onceWeigh',
    method: 'post',
    data
  })
};
// 送货单二次过磅
export const twiceWeigh = data => {
  return axios({
    url: '/api/sys/pur/twiceWeigh',
    method: 'post',
    data
  })
};
// 送货单二次过磅(修改)
export const updatePurArrivalEntry = data => {
  return axios({
    url: '/api/sys/pur/updatePurArrivalEntry',
    method: 'post',
    data
  })
};
// 送货单明细列表（用于二次称重的列表）
export const getPurArrivalEntryPage = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurArrivalEntryPage',
    method: 'post',
    data
  })
};
// 采购到货明细列表
export const getPurLedgerReportPage = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurLedgerReportPage',
    method: 'post',
    data
  })
};
// 送货单明细列表导出
export const exportPurLedger = data => {
  return axios({
    url: '/api/sys/pur/arrival/exportPurLedger',
    method: 'post',
    data
  })
};
//采购到货单车辆列表
export const getPurArrivalEntryCarNoPage = data => {
  return axios({
    url: '/api/sys/pur/arrival/getPurArrivalEntryCarNoPage',
    method: 'post',
    data
  })
};
// 采购入库单列表
export const getStkInPurchasePage = data => {
  return axios({
    url: '/api/sys/stk/getStkInPurchasePage',
    method: 'post',
    data
  })
};
// 采购入库单列表保存
export const saveStkInPurchase = data => {
  return axios({
    url: '/api/sys/stk/saveStkInPurchase',
    method: 'post',
    data
  })
};
// 采购入库单列表修改
export const updateStkInPurchase = data => {
  return axios({
    url: '/api/sys/stk/updateStkInPurchase',
    method: 'post',
    data
  })
};
// 修改来源是采购入库单的收支清单
export const updateStkInPurchaseAndExpenseBill = data => {
  return axios({
    url: '/api/sys/stk/updateStkInPurchaseAndExpenseBill',
    method: 'post',
    data
  })
};
// 采购入库单列表审核
export const stkAudit = data => {
  return axios({
    url: '/api/sys/stk/audit',
    method: 'post',
    data
  })
};
// 采购入库单列表反审核
export const stkUnAudit = data => {
  return axios({
    url: '/api/sys/stk/unAudit',
    method: 'post',
    data
  })
};
// 采购入库单列表删除
export const deleteStkInPurchases = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInPurchases',
    method: 'post',
    data
  })
};
// 采购入库单明细列表
export const getStkInPurchaseEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInPurchaseEntryPage',
    method: 'post',
    data
  })
};
// 采购入库单明细列表 删除
export const deleteStkInPurchaseEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInPurchaseEntrys',
    method: 'post',
    data
  })
};
// 采购结算
export const purchaseSettle = data => {
  return axios({
    url: '/api/sys/stk/purchaseSettle',
    method: 'post',
    data
  })
};
// 采购反结算
export const unPurchaseSettle = data => {
  return axios({
    url: '/api/sys/stk/unPurchaseSettle',
    method: 'post',
    data
  })
};
// 获取质检指标单价扣减
export const getQualityStandardList = data => {
  return axios({
    url: '/api/sys/stk/getQualityStandardList',
    method: 'post',
    data
  })
};

// 产成品入库单列表
export const getStkInProductPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInProductPage',
    method: 'post',
    data
  })
};
// 保存产成品入库单
export const saveStkInProductSerial = data => {
  return axios({
    url: '/api/sys/stk/saveStkInProductSerial',
    method: 'post',
    data
  })
};
// 修改产成品入库单
export const updateStkInProductSerial = data => {
  return axios({
    url: '/api/sys/stk/updateStkInProductSerial',
    method: 'post',
    data
  })
};
// 删除产成品入库单
export const deleteStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInProducts',
    method: 'post',
    data
  })
};
// 审核产成品入库单
export const auditStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/auditStkInProducts',
    method: 'post',
    data
  })
};
// 反审核产成品入库单
export const unauditStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/unauditStkInProducts',
    method: 'post',
    data
  })
};
// 作废产成品入库单
export const cancelStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/cancelStkInProducts',
    method: 'post',
    data
  })
};
// 产成品入库单明细列表
export const getStkInProductEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInProductEntryPage',
    method: 'post',
    data
  })
};
// 产成品入库列号明细列表
export const getStkInProductSerialPage = data => {
  return axios({
    url: '/api/sys/stk/in/product/serial/getStkInProductSerialPage',
    method: 'post',
    data
  })
};

// 产成品退货单列表
export const getStkInProductReturnPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInProductReturnPage',
    method: 'post',
    data
  })
};
// 保存产成品退库单
export const saveStkInProductReturnSerial = data => {
  return axios({
    url: '/api/sys/stk/saveStkInProductReturnSerial',
    method: 'post',
    data
  })
};
// 修改产成品退库单
export const updateStkInProductReturnSerial = data => {
  return axios({
    url: '/api/sys/stk/updateStkInProductReturnSerial',
    method: 'post',
    data
  })
};
// 删除产成品退库单
export const deleteStkInProductReturns = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInProductReturns',
    method: 'post',
    data
  })
};
// 审核产成品退库单
export const auditStkInProductReturn = data => {
  return axios({
    url: '/api/sys/stk/auditStkInProductReturn',
    method: 'post',
    data
  })
};
// 反审核产成品退库单
export const unAuditStkInProductReturn = data => {
  return axios({
    url: '/api/sys/stk/unAuditStkInProductReturn',
    method: 'post',
    data
  })
};
// 作废产成品退库单
export const cancelStkInProductReturns = data => {
  return axios({
    url: '/api/sys/stk/cancelStkInProductReturns',
    method: 'post',
    data
  })
};
// 产成品退货单明细列表
export const getStkInProductReturnEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInProductReturnEntryPage',
    method: 'post',
    data
  })
};
// 产成品退货单明细列表
export const getStkInProductReturnSerialPage = data => {
  return axios({
    url: '/api/sys/stk/in/product/return/getStkInProductReturnSerialPage',
    method: 'post',
    data
  })
};
// 采购过磅单核对
export const checkFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/checkFlag',
    method: 'post',
    data
  })
};
// 采购过磅单反核对
export const unCheckFlag = data => {
  return axios({
    url: '/api/sys/pur/arrival/unCheckFlag',
    method: 'post',
    data
  })
};
// 采购过磅单变更
export const updatePurArrivalOther = data => {
  return axios({
    url: '/api/sys/pur/arrival/updatePurArrivalOther',
    method: 'post',
    data
  })
};
// 采购正式合同
export const getFormalContract = data => {
  return axios({
    url: '/api/sys/pur/order/getFormalContract',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表
export const getPurOrderContainerPage = data => {
  return axios({
    url: '/api/sys/pur/order/container/getPurOrderContainerPage',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表(新)
export const getContainerPage = data => {
  return axios({
    url: '/api/sys/meter/getContainerPage',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表新增
export const savePurOrderContainer = data => {
  return axios({
    url: '/api/sys/pur/order/container/savePurOrderContainer',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表修改
export const updatePurOrderContainer = data => {
  return axios({
    url: '/api/sys/pur/order/container/updatePurOrderContainer',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表确定
export const purOrderContainerConfirm = data => {
  return axios({
    url: '/api/sys/pur/order/container/purOrderContainerConfirm',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表删除
export const deletePurOrderContainers = data => {
  return axios({
    url: '/api/sys/pur/order/container/deletePurOrderContainers',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表提交（报柜结束）
export const completed = data => {
  return axios({
    url: '/api/sys/pur/order/completed',
    method: 'post',
    data
  })
};
// 采购订单柜号单列表反提交（取消报柜结束）
export const cancelCompleted = data => {
  return axios({
    url: '/api/sys/pur/order/cancelCompleted',
    method: 'post',
    data
  })
};
// 修改到货单合同
export const modifyPurArrivalContract = data => {
  return axios({
    url: '/api/sys/pur/arrival/modifyPurArrivalContract',
    method: 'post',
    data
  })
};
// 付款单发票明细列表
export const getFinPaymentEntryPage = data => {
  return axios({
    url: '/api/sys/fin/payment/entry/getFinPaymentEntryPage',
    method: 'post',
    data
  })
};
// 付款单发票明细列表新增
export const addInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/addInvoice',
    method: 'post',
    data
  })
};
// 付款单发票明细列表新增
export const addInvoices = data => {
  return axios({
    url: '/api/sys/pur/arrival/addInvoices',
    method: 'post',
    data
  })
};
// 付款单发票明细列表修改
export const modifyInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/modifyInvoice',
    method: 'post',
    data
  })
};
// 付款单发票明细列表删除
export const deleteInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/deleteInvoice',
    method: 'post',
    data
  })
};
// 付款单发票明细列表提交
export const submitInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/submitInvoice',
    method: 'post',
    data
  })
};
// 付款单发票明细列表审核
export const auditInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/auditInvoice',
    method: 'post',
    data
  })
};
// 付款单发票明细列表反审
export const cancelAuditInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/cancelAuditInvoice',
    method: 'post',
    data
  })
};
// 付款单发票明细列表导入
export const uploadInvoice = data => {
  return axios({
    url: '/api/sys/pur/arrival/uploadInvoice',
    method: 'post',
    data
  })
};
// 申请表列表
export const getStkApplicationPage = data => {
  return axios({
    url: '/api/sys/stk/application/getStkApplicationPage',
    method: 'post',
    data
  })
};
// 申请表列表新增
export const saveStkApplication = data => {
  return axios({
    url: '/api/sys/stk/application/saveStkApplication',
    method: 'post',
    data
  })
};
// 申请表列表修改
export const updateStkApplication = data => {
  return axios({
    url: '/api/sys/stk/application/updateStkApplication',
    method: 'post',
    data
  })
};
// 申请表列表删除
export const deleteStkApplications = data => {
  return axios({
    url: '/api/sys/stk/application/deleteStkApplications',
    method: 'post',
    data
  })
};
// 申请表列表明细
export const getStkApplicationEntryPage = data => {
  return axios({
    url: '/api/sys/stk/application/entry/getStkApplicationEntryPage',
    method: 'post',
    data
  })
};
// 申请表列表申请人审批/反审批
export const applicantExamine = data => {
  return axios({
    url: '/api/sys/stk/application/applicantExamine',
    method: 'post',
    data
  })
};
// 申请表列表厂部审批/反审批
export const factoryExamine = data => {
  return axios({
    url: '/api/sys/stk/application/factoryExamine',
    method: 'post',
    data
  })
};
// 申请表列表采购部审批/反审批
export const purchaseExamine = data => {
  return axios({
    url: '/api/sys/stk/application/purchaseExamine',
    method: 'post',
    data
  })
};
// 申请表列表公司审批/反审批
export const companyExamine = data => {
  return axios({
    url: '/api/sys/stk/application/companyExamine',
    method: 'post',
    data
  })
};
// 申请表列表保安部审批/反审批
export const securityExamine = data => {
  return axios({
    url: '/api/sys/stk/application/securityExamine',
    method: 'post',
    data
  })
};
// 工作联络函列表
export const getStkContactLetterPage = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/getStkContactLetterPage',
    method: 'post',
    data
  })
};
// 工作联络函列表新增
export const saveStkContactLetter = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/saveStkContactLetter',
    method: 'post',
    data
  })
};
// 工作联络函列表修改
export const updateStkContactLetter = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/updateStkContactLetter',
    method: 'post',
    data
  })
};
// 工作联络函列表删除
export const deleteStkContactLetters = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/deleteStkContactLetters',
    method: 'post',
    data
  })
};
//工作联络函提交
export const letterSubmitData = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/submitData',
    method: 'post',
    data
  })
};
// 工作联络函列表明细
export const getStkContactLetterEntryPage = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/entry/getStkContactLetterEntryPage',
    method: 'post',
    data
  })
};
// 工作联络函列表拟稿部门审批/(反审批)
export const examineDraftDept = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/examineDraftDept',
    method: 'post',
    data
  })
};
// 工作联络函列表拟稿部门2审批/(反审批)
export const examineDraftDeptTwo = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/examineDraftDeptTwo',
    method: 'post',
    data
  })
};
// 工作联络函列表接收部门审批/(反审批)
export const examineReceiveDept = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/examineReceiveDept',
    method: 'post',
    data
  })
};
// 工作联络函列表接收部门2审批/(反审批)
export const examineReceiveDeptTwo = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/examineReceiveDeptTwo',
    method: 'post',
    data
  })
};
// 工作联络函列表保安审批/反审批
export const examineSecurity = data => {
  return axios({
    url: '/api/sys/stk/contact/letter/examineSecurity',
    method: 'post',
    data
  })
};
// 供应商税负列表
export const getPartnerTaxBurdenPage = data => {
  return axios({
    url: '/api/sys/getPartnerTaxBurdenPage',
    method: 'post',
    data
  })
};
// 税负变化表列表
export const getPurTaxBurdenPage = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/getPurTaxBurdenPage',
    method: 'post',
    data
  })
};
// 保存税负变化表
export const savePurTaxBurden = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/savePurTaxBurden',
    method: 'post',
    data
  })
};
// 修改税负变化表
export const updatePurTaxBurden = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/updatePurTaxBurden',
    method: 'post',
    data
  })
};
// 删除税负变化表
export const deletePurTaxBurdens = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/deletePurTaxBurdens',
    method: 'post',
    data
  })
};
// 提交税负变化表
export const applyPurTaxBurden = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/applyPurTaxBurden',
    method: 'post',
    data
  })
};
// 反提交税负变化表
export const unapplyPurTaxBurden = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/unapplyPurTaxBurden',
    method: 'post',
    data
  })
};
// 供应商税负明细表列表
export const getPurPartnerBurdenPage = data => {
  return axios({
    url: '/api/sys/pur/partner/burden/getPurPartnerBurdenPage',
    method: 'post',
    data
  })
};
// 查询最新供应商税负表
export const getPurTaxBurdenNew = data => {
  return axios({
    url: '/api/sys/pur/tax/burden/getPurTaxBurdenNew',
    method: 'post',
    data
  })
};
// 采购订单车辆录入表列表
export const getPurOrderCarPage = data => {
  return axios({
    url: '/api/sys/pur/order/car/getPurOrderCarPage',
    method: 'post',
    data
  })
};
// 保存采购订单车辆录入表
export const savePurOrderCar = data => {
  return axios({
    url: '/api/sys/pur/order/savePurOrderCar',
    method: 'post',
    data
  })
};
// 修改采购订单车辆录入表
export const updatePurOrderCar = data => {
  return axios({
    url: '/api/sys/pur/order/car/updatePurOrderCar',
    method: 'post',
    data
  })
};
// 删除采购订单车辆录入表
export const deletePurOrderCars = data => {
  return axios({
    url: '/api/sys/pur/order/car/deletePurOrderCars',
    method: 'post',
    data
  })
};
// 查询供应商税负
export const getPurTaxBurdenByPartnerId = data => {
  return axios({
    url: '/api/sys/pur/order/getPurTaxBurdenByPartnerId',
    method: 'post',
    data
  })
};
// 保存供应商税负
export const savePurPartnerBurden = data => {
  return axios({
    url: '/api/sys/pur/partner/burden/savePurPartnerBurden',
    method: 'post',
    data
  })
};
// 提交供应商税负审核
export const submitPartnerBurden = data => {
  return axios({
    url: '/api/sys/pur/partner/burden/submitPartnerBurden',
    method: 'post',
    data
  })
};
// 获取供应商税负历史记录
export const getPurPartnerBurdenHistoryPage = data => {
  return axios({
    url: '/api/sys/pur/partner/burden/history/getPurPartnerBurdenHistoryPage',
    method: 'post',
    data
  })
};
// 同步供应商税负
export const synchronizePartnerBurden = data => {
  return axios({
    url: '/api/sys/pur/partner/burden/synchronizePartnerBurden',
    method: 'post',
    data
  })
};
// 修改广东办车号场地
export const updateCarNo = data => {
  return axios({
    url: '/api/sys/pur/arrival/updateCarNo',
    method: 'post',
    data
  })
};
// 物流合同表列表
export const getPurLogisticsPage = data => {
  return axios({
    url: '/api/sys/pur/logistics/getPurLogisticsPage',
    method: 'post',
    data
  })
};
// 物流合同表列表新增
export const savePurLogistics = data => {
  return axios({
    url: '/api/sys/pur/logistics/savePurLogistics',
    method: 'post',
    data
  })
};
// 物流合同表列表修改
export const updatePurLogistics = data => {
  return axios({
    url: '/api/sys/pur/logistics/updatePurLogistics',
    method: 'post',
    data
  })
};
// 物流合同表列表价格修改
export const getFreightPrice = data => {
  return axios({
    url: '/api/sys/pur/logistics/getFreightPrice',
    method: 'post',
    data
  })
};
// 物流合同表列表审核后修改
export const updatePurLogisticsBankCard = data => {
  return axios({
    url: '/api/sys/pur/logistics/updatePurLogisticsBankCard',
    method: 'post',
    data
  })
};
// 物流合同表列表删除
export const deletePurLogisticss = data => {
  return axios({
    url: '/api/sys/pur/logistics/deletePurLogisticss',
    method: 'post',
    data
  })
};
// 物流合同表列表提交
export const applyPurLogistics = data => {
  return axios({
    url: '/api/sys/pur/logistics/applyPurLogistics',
    method: 'post',
    data
  })
};
// 物流合同表列表明细
export const getPurLogisticsEntryPage = data => {
  return axios({
    url: '/api/sys/pur/logistics/getPurLogisticsEntryPage',
    method: 'post',
    data
  })
};
// 物流合同表关闭
export const closePurLogistics = data => {
  return axios({
    url: '/api/sys/pur/logistics/closePurLogistics',
    method: 'post',
    data
  })
};
// 柜号绑定运费合同承运商
export const updateCarrier = data => {
  return axios({
    url: '/api/sys/pur/order/container/updateCarrier',
    method: 'post',
    data
  })
};
// 运费单列表
export const getPurFreightPage = data => {
  return axios({
    url: '/api/sys/pur/freight/getPurFreightPage',
    method: 'post',
    data
  })
};
// 运费单列表批量新增
export const batchSavePurFreight = data => {
  return axios({
    url: '/api/sys/pur/freight/batchSavePurFreight',
    method: 'post',
    data
  })
};
// 运费单列表修改
export const updatePurFreight = data => {
  return axios({
    url: '/api/sys/pur/freight/updatePurFreight',
    method: 'post',
    data
  })
};
// 运费单列表审核后修改
export const batchUpdatePurFreightAmount = data => {
  return axios({
    url: '/api/sys/pur/freight/batchUpdatePurFreightAmount',
    method: 'post',
    data
  })
};
// 运费单列表删除
export const deletePurFreights = data => {
  return axios({
    url: '/api/sys/pur/freight/deletePurFreights',
    method: 'post',
    data
  })
};
// 运费单列表确认
export const auditPurFreights = data => {
  return axios({
    url: '/api/sys/pur/freight/auditPurFreights',
    method: 'post',
    data
  })
};
// 运费单列表反确认
export const unauditPurFreights = data => {
  return axios({
    url: '/api/sys/pur/freight/unauditPurFreights',
    method: 'post',
    data
  })
};
// 运费单列表反确认
export const settlePurFreight = data => {
  return axios({
    url: '/api/sys/pur/freight/settlePurFreight',
    method: 'post',
    data
  })
};
// 结算单列表
export const getPurFreightSettleList = data => {
  return axios({
    url: '/api/sys/pur/freight/getPurFreightSettleList',
    method: 'post',
    data
  })
};
// 结算单列表反结算
export const cancelSettlePurFreight = data => {
  return axios({
    url: '/api/sys/pur/freight/cancelSettlePurFreight',
    method: 'post',
    data
  })
};
// 提交结算单
export const applyPurFreightSettle = data => {
  return axios({
    url: '/api/sys/pur/freight/applyPurFreightSettle',
    method: 'post',
    data
  })
};
// 运费单列表上传附件
export const uploadFreightFile = data => {
  return axios({
    url: '/api/sys/pur/freight/uploadFreightFile',
    method: 'post',
    data
  })
};
// 新增运费付款单
export const saveFreightFinPayment = data => {
  return axios({
    url: '/api/sys/fin/payment/saveFreightFinPayment',
    method: 'post',
    data
  })
};
// 修改运费付款单
export const updateFreightFinPayment = data => {
  return axios({
    url: '/api/sys/fin/payment/updateFreightFinPayment',
    method: 'post',
    data
  })
};
// 运费付款单:新增发票,无权限限制
export const updateFreightFinPaymentInvoiceThu = data => {
  return axios({
    url: '/api/sys/fin/payment/updateFreightFinPaymentInvoiceThu',
    method: 'post',
    data
  })
};
// 根据预付款id查询预付款
export const getAdvancePaymentByIdFinPayment = data => {
  return axios({
    url: '/api/sys/fin/payment/getAdvancePaymentByIdFinPayment',
    method: 'post',
    data
  })
};
// 根据合同和供应商查询报柜信息
export const getPurOrderContainerByContract = data => {
  return axios({
    url: '/api/sys/pur/order/getPurOrderContainerByContract',
    method: 'post',
    data
  })
};
// 根据合同id查询物流公司
export const getLogisticsCompanyByContract = data => {
  return axios({
    url: '/api/sys/getLogisticsCompanyByContract',
    method: 'post',
    data
  })
};
// 复核
export const review = data => {
  return axios({
    url: '/api/sys/pur/order/review',
    method: 'post',
    data
  })
}
// 反复核
export const repeatedNuclear = data => {
  return axios({
    url: '/api/sys/pur/order/repeatedNuclear',
    method: 'post',
    data
  })
}
// 采购订单柜号单列表
export const getPurOrderContainerPage1 = data => {
  return axios({
    url: '/api/sys/pur/order/getPurOrderContainerPage',
    method: 'post',
    data
  })
};
//装柜复核列表导出
export const exportPurOrderContainerPage = data => {
  return axios({
    url: '/api/sys/pur/order/exportPurOrderContainerPage',
    method: 'post',
    data
  })
};
//移库到货单结算并且审批
export const submitPurArrival = data => {
  return axios({
    url: '/api/sys/pur/arrival/submitPurArrival',
    method: 'post',
    data
  })
};
// 订单装柜情况列表
export const purOrderContainerCircumstanceFormPageList = data => {
  return axios({
    url: '/api/sys/pur/order/purOrderContainerCircumstanceFormPageList',
    method: 'post',
    data
  })
};
// 订单装柜情况列表导出
export const exportPurOrderContainerCircumstanceFormPageList = data =>{
  return axios({
    url: '/api/sys/pur/order/exportPurOrderContainerCircumstanceFormPageList',
    method: 'post',
    data
  })
}
//采购到货单核对导出
export const exportPurArrivAlList = data =>{
  return axios({
    url:'/api/sys/pur/arrival/exportPurArrivalList',
    method:'post',
    data
  })
}
//采购到货单核对导出
export const exportArrivalEntryListBySettleNo = data =>{
  return axios({
    url:'/api/sys/pur/arrival/exportArrivalEntryListBySettleNo',
    method:'post',
    data
  })
}
// 结算单附件上传后保存
export const uploadSettleFile = data => {
  return axios({
    url: '/api/sys/pur/arrival/uploadSettleFile',
    method: 'post',
    data
  })
};
export const settleSubmitApproval = data => {
  return axios({
    url: '/api/sys/pur/arrival/settleSubmitApproval',
    method: 'post',
    data
  })
};

// 合同模板导出（根据ID导出）
export const contractTemplateExport = data => {
  return axios({
    url: '/api/sys/pur/order/contractTemplateExport',
    method: 'post',
    data,
    responseType: 'blob'
  })
};
//判断是否重复制单
export const reproduceOrder = data =>{
  return axios({
    url: '/api/sys/pur/freight/reproduceOrder',
    method: 'post',
    data
  })
}
//判断是否重复制单
export const updatePurPartnerBurden = data =>{
  return axios({
    url: '/api/sys/pur/partner/burden/updatePurPartnerBurden',
    method: 'post',
    data
  })
}
//采购重车出场
export const heavyCarOut = data =>{
  return axios({
    url: '/api/sys/pur/arrival/heavyCarOut',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/OrderPurchase.js